import { useGraphQLQuery } from '@betterment/graphql';
import { Box, H2, Table } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { HouseholdDocument } from './graphql/query.household.generated';
import { SwitchBillingPlanTableRow } from './SwitchBillingPlanTableRow';

import { FirmDocument } from '../../ClientBilling/BillingPlans/graphql/query.firm.generated';

const TABLE_HEADER_COLUMNS = ['Name', 'Advisory fee', 'Assigned to', 'Bill from', 'Platform fee paid by'];

export const SwitchBillingPlanTable = () => {
  const householdId = useRequiredParam('householdId');
  const { data: householdData } = useGraphQLQuery(HouseholdDocument, {
    variables: { id: householdId },
    throwOnError: true,
  });
  const { data: firmData } = useGraphQLQuery(FirmDocument);

  if (!householdData || !firmData) return <CardLoader />;
  if (householdData.household.__typename === 'RecordNotFoundResult') return null;

  const { effectivePlatformFee } = householdData.household;

  return (
    <>
      <H2>Change billing plan.</H2>
      <Box
        css={{
          my: 'space.400',
          py: 'space.150',
          alignSelf: 'stretch',
          borderRadius: 'medium',
          border: 'thin',
          borderColor: 'border',
          bg: 'background.surface',
        }}
      >
        <Table>
          <Table.Header>
            <Table.Row>
              {TABLE_HEADER_COLUMNS.map(column => (
                <Table.ColumnHeaderCell key={column}>{column}</Table.ColumnHeaderCell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {firmData.firm.billingPlans.map(billingPlan => (
              <SwitchBillingPlanTableRow
                key={billingPlan.id}
                billingPlan={billingPlan}
                effectivePlatformFee={effectivePlatformFee}
              />
            ))}
          </Table.Body>
        </Table>
      </Box>
    </>
  );
};
